












































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { User } from "@/models";

interface SelectedObject {
  [key: string]: boolean;
  radio: boolean;
  tv: boolean;
}

@Component
export default class MediaSelector extends Vue {
  @Prop() readonly value!: SelectedObject;
  @Prop({ default: false }) readonly expanded?: boolean;

  @Getter("user") user!: User;

  selected: SelectedObject = {
    radio: true,
    tv: false,
  };

  locked: SelectedObject = {
    radio: false,
    tv: false,
  };

  created() {
    if (this.value) {
      this.selected = { ...this.value };
    }

    if (!this.user?.isAdmin) {
      this.locked.radio = this.user.radio == false;
      this.locked.tv = this.user.tv == false;
    }
  }

  toggleRadio() {
    if (this.isLocked("tv") || this.isLocked("radio")) {
      return;
    }

    this.selected.radio = !this.selected.radio;

    if (this.selected.radio === false && this.selected.tv === false) {
      this.selected.tv = true;
    }

    this.emitValue();
  }

  toggleTv() {
    if (this.isLocked("radio") || this.isLocked("tv")) {
      return;
    }

    this.selected.tv = !this.selected.tv;

    if (this.selected.tv === false && this.selected.radio === false) {
      this.selected.radio = true;
    }

    this.emitValue();
  }

  buttonClass(type: string) {
    return this.selected[type] ? "btn-primary" : "btn-outline-secondary";
  }

  isLocked(type: string) {
    return this.locked[type];
  }

  emitValue() {
    this.$emit("input", this.selected);
  }
}
